import React from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import ErrorID from "../../Other/ErrorID";
import { PageHeader, PageShell } from "../../UI/Page";
import { inputCls } from "../wdUi";

const ACCENTS = {
  emerald: { tone: "emerald", icon: CheckCircleOutlineIcon },
  red: { tone: "rose", icon: HighlightOffIcon },
  sky: { tone: "sky", icon: EventAvailableOutlinedIcon },
};

// Page shell for the accept / reject / schedule screens a manager lands on
// from the request list or an emailed link: header, optional error banner,
// an app-card body (children) and a footer slot for action buttons.
export const RequestActionShell = ({
  title,
  accent = "sky",
  icon,
  id,
  showError,
  children,
  footer,
}) => {
  const accentMeta = ACCENTS[accent] || ACCENTS.sky;
  return (
    <PageShell size="md">
      <PageHeader
        icon={icon || accentMeta.icon}
        tone={accentMeta.tone}
        eyebrow="Exterior Orders"
        title={title}
        description={`Request #${id}`}
      />

      {showError && (
        <div className="mb-4">
          <ErrorID id={id} />
        </div>
      )}

      <div className="app-card rounded-2xl border p-5 sm:p-6">{children}</div>

      {footer && (
        <div className="mt-5 flex flex-wrap justify-end gap-3">{footer}</div>
      )}
    </PageShell>
  );
};

export const SectionLabel = ({ children }) => (
  <h2 className="mb-3 text-sm font-semibold">{children}</h2>
);

// Read-only labelled field (label above value).
export const Field = ({ icon, label, value }) => (
  <div className="app-surface h-full rounded-xl border px-3 py-2.5">
    <div className="app-muted flex items-center gap-1.5 text-xs font-medium">
      {icon}
      {label}
    </div>
    <p className="mt-0.5 break-words text-sm font-semibold">
      {value === 0 || value ? value : "—"}
    </p>
  </div>
);

export const NotesInput = ({ value, onChange }) => (
  <div>
    <label
      htmlFor="request-action-notes"
      className="mb-1.5 block text-sm font-semibold"
    >
      Notes
    </label>
    <textarea
      id="request-action-notes"
      rows="3"
      value={value}
      onChange={onChange}
      placeholder="Enter optional notes"
      className={inputCls}
    />
  </div>
);

// Shared input styling for react-datepicker inputs.
export const datePickerClass = `${inputCls} !w-48`;
